import replaceWithMarkup from "../utils/replaceWithMarkup";
import { getPostsMarkup } from '../endpoints/query/getPosts';

/**
 *
 * Loads custom post type posts on Load More button click ( adweek.com/sponsored/ archive uses this )
 *
 * @param {string} morePostsTrigger                             Query string for triggering the loading and markup of posts.
 * @param {string} replaceWithPosts                             Query string for node that new posts will replace.
 * @param {'teaser_partner_more_grid' | 'index_item'} post_type Name of the post_type
 * @param {number} page                                         Pagination index.
 * @param {number} postPerPage                                  Number of posts per page.
 */
export default function getLatestNewsPostTypePosts( morePostsTrigger, replaceWithPosts, post_type, page, postPerPage ) {

    const trigger = document.querySelector( morePostsTrigger );
   
    trigger.addEventListener( 'click', function( e ) {

        e.preventDefault();
        const btnOriginalHtml = trigger.querySelector( 'a' ).innerHTML;
        const loaderHtml = '<div class="la-ball-pulse la-dark la-sm"><div></div><div></div><div></div></div>';
        trigger.querySelector( 'a' ).innerHTML = loaderHtml;
        const markup = post_type === 'event' ? 'teaser_partner_more_grid' : 'index_item';

        getPostsMarkup( post_type, page, postPerPage, markup )
            .then( markup => {

                const reinitialize = (markup !== '');
                trigger.querySelector( 'a' ).innerHTML = btnOriginalHtml;
                replaceWithMarkup( trigger, markup, replaceWithPosts, reinitialize );

                if ( reinitialize ) {

                    getLatestNewsPostTypePosts( morePostsTrigger, replaceWithPosts, post_type, ++page, postPerPage );
                }

            });

    }, { once: true } );

}




/**
 * @deprecated
 *
 * @param taxonomy
 * @param taxonomyTerm
 * @param page
 * @return {Promise<any>}
 */
async function apiCall( post_type, page = 1 ) {

    console.log( 'custom post type endpoint called' );

    const url = `${window.location.origin}/wp-json/adw-post/v1/post-index-markup/custom_post_type/posts/?page=${page}`;

    const response  = await fetch(url);
    if (response.status !== 200) {
        console.error(`No route is established to retrieve '${post_type}' posts`);
        return new Promise( ( resolve ) => resolve('') );
    } else {
        return await response.json();
    }
}
